import { $mount, mount } from '../../../js/dom-lifecycle';

$mount('.translation-locale-select').on('change', function () {
    window.location = $(this).data('href').replace('xx', $(this).val()) + window.location.hash;
});

// Bootstrap comes from EasyAdmin's app.js, which runs after this bundle
window.addEventListener('load', () => mount('[data-bs-toggle="tooltip"]', el => {
    bootstrap.Tooltip.getOrCreateInstance(el);
}));

// EasyAdmin renders POST actions in dropdowns with an empty <form>, without our CSRF token
mount('[data-ea-action-form-id][data-csrf-token]', el => {
    const input = Object.assign(document.createElement('input'), {type: 'hidden', name: '_token', value: el.dataset.csrfToken});
    document.getElementById(el.dataset.eaActionFormId)?.append(input);
});

$mount('[data-bs-dismiss="modal"]').on('click', function () {
    bootstrap.Modal.getOrCreateInstance(this.closest('.modal')).hide();
});

$mount('[data-open-modal]').on('click', function () {
    bootstrap.Modal.getOrCreateInstance(document.querySelector(this.dataset.openModal)).show();
});

document.addEventListener('show.bs.modal', function (e) {
    const modal = e.target;

    // Move opted-in modals to <body> so they escape a parent modal's stacking context.
    if (modal.hasAttribute('data-modal-to-body') && modal.parentElement !== document.body) {
        const placeholder = document.createComment('modal-placeholder');
        modal.before(placeholder);
        document.body.appendChild(modal);
        $(modal).one('hidden.bs.modal', () => {
            placeholder.parentNode ? placeholder.replaceWith(modal) : modal.remove();
        });
    }

    // Stack each modal and its backdrop above the previously open one.
    const zIndex = 1055 + document.querySelectorAll('.modal.show').length * 20;
    modal.style.zIndex = zIndex;
    setTimeout(() => {
        document.querySelectorAll('.modal-backdrop:not(.modal-stacked)').forEach(backdrop => {
            backdrop.style.zIndex = zIndex - 5;
            backdrop.classList.add('modal-stacked');
        });
    });
});
